import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { FormDropDown } from "../../components/form/dropdown";
import { FormImageField } from "../../components/form/image";
import { FormTextAreaField } from "../../components/form/text-area";
import { FormToggleSwitch } from "../../components/form/checkbox";
import { api } from "../../redux/apis/api";

const CreateCompany = () => {
  const naviagte = useNavigate();
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const initialValues = {
    name: "",
    address: "",
    state_id: "",
    city_id: "",
    email: "",
    phone_number: "",
    logo: "",
    pan_number: "",
    gst_number: "",
    only_associated_data: false,
    bank_account_number: "",
    bank_ifsc_code: "",
    bank_name: "",
    bank_account_holder_name: "",
    upi_id: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    email: Yup.string().required("Required").email("Invalid email"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/company/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/company/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Company - Create
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/company/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Create
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <div className="my-4">
                    <FormImageField name={"logo"} label={"logo"} />
                  </div>
                  <FormTextField
                    name={"name"}
                    label={"name"}
                    placeholder={`Enter company name`}
                  />
                  <FormTextField
                    name={"email"}
                    label={"email"}
                    placeholder={`Enter company email`}
                  />
                  <FormTextField
                    name={"phone_number"}
                    label={"phone number"}
                    placeholder={`Enter company phone number`}
                  />
                  <div className="my-4">
                    <FormDropDown
                      name="state_id"
                      label="state"
                      options={stateList}
                    />
                  </div>
                  <div className="my-4">
                    <FormDropDown
                      name="city_id"
                      label="city"
                      options={citiesList}
                    />
                  </div>
                  <div className="my-4">
                    <FormTextAreaField
                      name={"address"}
                      label={"address"}
                      placeholder={`Enter company address`}
                      rows={3}
                    />
                  </div>
                  <div className="my-4">
                    <FormTextField
                      name={"pan_number"}
                      label={"pan number"}
                      placeholder={`Enter pan number`}
                    />
                  </div>
                  <div className="my-4">
                    <FormTextField
                      name={"gst_number"}
                      label={"gst number"}
                      placeholder={`Enter gst number`}
                    />
                  </div>
                  <div className="my-4">
                    <FormToggleSwitch
                      name={"only_associated_data"}
                      label={"only associated data"}
                      value={values?.only_associated_data ?? false}
                    />
                  </div>
                </div>
              </section>
              <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
                <p>Bank Details</p>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"bank_account_number"}
                    label={"account number"}
                    placeholder={`Enter account number`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_ifsc_code"}
                    label={"bank ifsc code"}
                    placeholder={`Enter ifsc code`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_name"}
                    label={"bank name"}
                    placeholder={`Enter bank name`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_account_holder_name"}
                    label={"account holder name"}
                    placeholder={`Enter your account holder name`}
                  />
                </div>
                <FormTextField
                  name={"upi_id"}
                  label={"upi_id"}
                  placeholder={`Enter upi id`}
                />
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateCompany;
